export const ReceiptCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  HeaderRow: {
    flow: 'x',
    align: 'center flex-start',
    justifyContent: 'space-between',
    ReceiptNumber: { text: (el, s) => s.receiptNumber || '', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
    ReceiptDate: { text: (el, s) => s.receiptDate || '', fontSize: 'Y', color: 'inkMuted' }
  },

  PatientName: { text: (el, s) => s.patientName || '', fontSize: 'Z', color: 'inkText', fontWeight: '600' },

  Divider: { height: '1px', background: 'inkBorder' },

  DetailsSection: {
    flow: 'y',
    gap: 'Y',
    AmountPaidRow: {
      flow: 'x', justifyContent: 'space-between',
      Label: { text: '{{ amountPaid | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.amountPaid || '', fontSize: 'Z', fontWeight: '700', color: 'green' }
    },
    MethodRow: {
      flow: 'x', justifyContent: 'space-between',
      Label: { text: '{{ paymentMethod | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.method || '', fontSize: 'Z', fontWeight: '600', color: 'inkText' }
    },
    RemainingRow: {
      flow: 'x', justifyContent: 'space-between',
      Label: { text: '{{ remainingBalance | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: {
        text: (el, s) => s.remainingBalance || '\u20BE0',
        fontSize: 'Z',
        fontWeight: '700',
        color: (el, s) => s.remainingBalance && s.remainingBalance !== '\u20BE0' ? 'amber' : 'green'
      }
    }
  },

  ActionsRow: {
    flow: 'x',
    gap: 'Y',
    marginTop: 'Y',
    PrintBtn: { tag: 'button', text: '{{ print | polyglot }}', padding: 'Y Z', round: 'A', background: 'inkSurface', color: 'inkMuted', fontSize: 'Y', fontWeight: '600', cursor: 'pointer', border: 'none' },
    DownloadBtn: { tag: 'button', text: '{{ download | polyglot }}', padding: 'Y Z', round: 'A', background: 'inkSurface', color: 'inkMuted', fontSize: 'Y', fontWeight: '600', cursor: 'pointer', border: 'none' }
  }
}
